// src/components/blog/RelatedPostsSection.js
import React from 'react';
import { Link } from 'react-router-dom';
import { blogPostsData } from '../../data/blogPostsData'; // Accès à tous les posts
import BlogPostPreviewCard from './BlogPostPreviewCard'; // Réutilise la carte d'aperçu
import './RelatedPostsSection.css';

function RelatedPostsSection({ currentArticleSlug, currentArticleTags, maxPosts = 3, posts }) {
  if (!currentArticleTags || currentArticleTags.length === 0) {
    return null; // Pas de tags, pas de suggestions basées sur les tags
  }

  const sourcePosts = Array.isArray(posts) ? posts : blogPostsData;

  const relatedPosts = sourcePosts
    .filter(post => {
      // Exclut l'article actuel
      if (post.slug === currentArticleSlug) {
        return false;
      }
      // Vérifie s'il y a au moins un tag en commun
      return post.tags && post.tags.some(tag => currentArticleTags.includes(tag));
    })
    .slice(0, maxPosts); // Limite au nombre maximum de posts souhaité

  if (relatedPosts.length === 0) {
    return null; // Pas d'articles similaires trouvés
  }

  return (
    <aside className="related-posts-section">
      <h2>Vous pourriez aussi aimer</h2>
      <div className="related-posts-grid"> {/* Utilise la grille définie dans son CSS ou BlogPage.css */}
        {relatedPosts.map(post => (
          <BlogPostPreviewCard key={post.slug} post={post} />
        ))}
      </div>
    </aside>
  );
}

export default RelatedPostsSection;